import { createSlice } from '@reduxjs/toolkit'
import { EntityType, MataDataType } from '../../components/DTStudio/interfaces'

interface DTStudioState {
    selectedEntity: EntityType
    dataTypes: string[]
    attributeMetaDataOptions: MataDataType
}

const initialState: DTStudioState = {
    selectedEntity: {} as EntityType,
    dataTypes: [],
    attributeMetaDataOptions: {},
}

const dtStudioSlice = createSlice({
    name: 'dtStudio',
    initialState,
    reducers: {
        updateSelectedEntity(state, action) {
            state.selectedEntity = action.payload
        },
        setDataTypes(state, action) {
            state.dataTypes = action.payload
        },
        setAttributeMetaDataOptions(state, action) {
            state.attributeMetaDataOptions = action.payload
        },
    },
})

export const {
    updateSelectedEntity,
    setDataTypes,
    setAttributeMetaDataOptions,
} = dtStudioSlice.actions
export default dtStudioSlice.reducer
